import TablePage from './table';

export default {
  name: 'manage',
  extends: TablePage,
};
